// @flow
import { connect } from 'react-redux';

import competitionsInternationalesPlayer from 'components/competitionsInternationales/competitionsInternationalesPlayer';
import { fetchJoueur } from 'actions/joueurActions';

import type { DispatchType, StateType } from 'types/Actions';
import type { DispatchProps, StateProps } from 'components/competitionsInternationales/competitionsInternationalesPlayer';

export default connect(
  (state: StateType): StateProps => ({
    data: state.competitionsInternationalesState.data,
    status: state.competitionsInternationalesState.status,
    joueur: state.joueurState.joueur,
    joueurStatus: state.joueurState.status,
    userPref: state.userState.userPref
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchJoueur: (slug: string) => dispatch(fetchJoueur(slug))
  })
)(competitionsInternationalesPlayer);
